import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EnumUtilityService {
  
  constructor() { }

  enumToString<T>(enumObj: T, enumValue: number | string): string {
    return enumObj[enumValue];
  }
}
